// extracted by css-extract-rspack-plugin
export default {"adornment":"adornment-rH8obK","positionStart":"positionStart-WbwFPA","positionEnd":"positionEnd-C4n8s9"};